// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zfU09es1lun3vQmGEgzn {
  padding: 16px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]};
  margin-bottom: 36px;
  border-radius: 4px;
}

.PTslAthcwdhfCSQEMaWh {
  display: flex;
  min-height: 300px;
}

.PTslAthcwdhfCSQEMaWh .zfU09es1lun3vQmGEgzn {
  flex: 1;
  max-height: 350px;
  overflow-y: scroll;
  margin-bottom: 0;
}

.ukAWF0MuRJy0_ZpvLjSw, .PhDrXWxFB2j_OIUTboXX {
  width: 50px;
  padding: 18px 0;
  align-self: center;
  text-align: center;
  cursor: pointer;
}

.ukAWF0MuRJy0_ZpvLjSw:hover, .PhDrXWxFB2j_OIUTboXX:hover {
  background-color: whitesmoke;
}

.ukAWF0MuRJy0_ZpvLjSw.JyD6nAc8pTlO1lRiRwco:hover, .PhDrXWxFB2j_OIUTboXX.JyD6nAc8pTlO1lRiRwco:hover {
  background-color: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]};
}

.u3SGpXXukdEoHWkM0wTt {
  height: 50px;
  width: 50px;
}

.BzC_NApOzoExEaevMP0V {
    text-align: right;
    margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/waitlist-update/process-removals/components/step-review-send.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,8DAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,mDAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["@value colors: \"../../../../styles/colors.module.css\";\n@value hc-primary, hc-navy, hc-outline, hc-error, hc-secondary from colors;\n\n.editorContainer {\n  padding: 16px;\n  border: 1px solid hc-outline;\n  margin-bottom: 36px;\n  border-radius: 4px;\n}\n\n.previewContainer {\n  display: flex;\n  min-height: 300px;\n}\n\n.previewContainer .editorContainer {\n  flex: 1;\n  max-height: 350px;\n  overflow-y: scroll;\n  margin-bottom: 0;\n}\n\n.next, .prev {\n  width: 50px;\n  padding: 18px 0;\n  align-self: center;\n  text-align: center;\n  cursor: pointer;\n}\n\n.next:hover, .prev:hover {\n  background-color: whitesmoke;\n}\n\n.next.disabled:hover, .prev.disabled:hover {\n  background-color: none;\n  color: hc-secondary;\n}\n\n.btnSpacer {\n  height: 50px;\n  width: 50px;\n}\n\n.warning {\n    text-align: right;\n    margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../styles/colors.module.css"`,
	"hc-primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hcPrimary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hc-navy": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-navy"]}`,
	"hcNavy": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-navy"]}`,
	"hc-outline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hcOutline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hc-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hcError": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hc-secondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]}`,
	"hcSecondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]}`,
	"editorContainer": `zfU09es1lun3vQmGEgzn`,
	"previewContainer": `PTslAthcwdhfCSQEMaWh`,
	"next": `ukAWF0MuRJy0_ZpvLjSw`,
	"prev": `PhDrXWxFB2j_OIUTboXX`,
	"disabled": `JyD6nAc8pTlO1lRiRwco`,
	"btnSpacer": `u3SGpXXukdEoHWkM0wTt`,
	"warning": `BzC_NApOzoExEaevMP0V`
};
export default ___CSS_LOADER_EXPORT___;
